import React from 'react';
import { useTranslation } from 'react-i18next';

import Rebate from '@client/components/price/Rebate';
import { EAbilityActions, EAbilitySubjects } from '@client/hooks/useAbilities';
import { useAuth } from '@client/hooks/useAuth';
import {
  CNsDiscount,
  CNsPrice,
  type ECurrency,
  type EDurationTypes,
} from '@common/types';

import type { FormInstance } from 'antd';

type TSubscriptionDiscountProps = {
  formRef: FormInstance<any>;
  disabled: boolean;
  loading: boolean;
  currencies: (keyof typeof ECurrency)[];
  durationTypes: (keyof typeof EDurationTypes)[];
  renderScheduler: (readOnlyFields?: string[]) => React.ReactNode;
  children?: React.ReactNode;
  priceMin?: number;
};

export const SubscriptionDiscount: React.FC<TSubscriptionDiscountProps> = (
  props,
) => {
  const { t } = useTranslation();
  const { ability } = useAuth();

  const {
    formRef,
    disabled,
    durationTypes = [],
    currencies = [],
    loading,
    children,
    renderScheduler,
  } = props;

  const discountProps = {
    formRef,
    disabled,
    currencies,
    durationTypes,
    loading,
  };

  return (
    <Rebate.Discount
      {...discountProps}
      prefix={[CNsPrice]}
      header={t('price.priceInfo', { type: t('price.sale') })}
      discountHeader={t('price.discountInfo', { header: t('price.title') })}
      namespace={CNsDiscount}
      priceMin={0}
      renderScheduler={renderScheduler}
      canBeDiscounted={ability.can(
        EAbilityActions.UPDATE,
        `${EAbilitySubjects.FEATURE}.${EAbilitySubjects.DISCOUNT}`,
      )}
      canBePeriodic={ability.can(
        EAbilityActions.UPDATE,
        `${EAbilitySubjects.FEATURE}.${EAbilitySubjects.PERIODIC}`,
      )}
    >
      {children}
    </Rebate.Discount>
  );
};
